import { buildLoader } from '../../util/GenericLoader';
import { fetchSubmissionStatusActionCreator } from '../../../redux/actions/rtemFiles';

export default buildLoader(fetchSubmissionStatusActionCreator);
